module.exports = __webpack_public_path__ + "static/tayla-e992d01e15036e24ab9c74351acc843d.webm";